import React, { useState } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import styles from './GSTModal.module.css';

interface GSTModalProps {
    PayModal: any;
    setGst: (open: any) => void;
}

const GSTModal: React.FC<GSTModalProps> = ({ PayModal, setGst }) => {
    const [gstNumber, setGstNumber] = useState('');
    const [tooltipMessage, setTooltipMessage] = useState('Input credit under GST will not be applicable if GST number not provided.');
    const [errorMsg, setErrorMsg] = useState('');

    const handleGstNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setGstNumber(value);
        setErrorMsg(''); // Clear error message on change

        if (value === '') {
            setTooltipMessage('Input credit under GST will not be applicable if GST number not provided.');
        } else if (value.length <= 35) {
            setTooltipMessage('Please enter a valid GST Number (Max 35 Char)');
        } else {
            setTooltipMessage('');
        }
    };

    const isValidGst = (gstNo: string): boolean => {
        const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/;
        return gstRegex.test(gstNo);
    };

    const payHandler = () => {
        if (gstNumber && !isValidGst(gstNumber)) {
            setErrorMsg('Invalid GST Number');
            return;
        }else{
            // const gstData = {
            //     gstno:gstNumber
            //   }
            //   localStorage.setItem("gstData", JSON.stringify(gstData));
        setGst(gstNumber);
        PayModal(gstNumber);
        document.body.classList.add("no-overflow");}
    };
    const nonGstpayHandler = () => {
        setGst("");
        PayModal(true);
        document.body.classList.add("no-overflow");
    };

    return (
        <div className={styles.GstModalWrapper}>
            <div className={styles.GstModal}>
                <div className={styles.GstModalTitle}>
                    Do you have a GST number?{' '}
                    <span className={styles.GstModalTitleFade}>(Optional)</span>
                </div>
                {tooltipMessage && <div className={styles.Tooltip}><span className={styles.TooltipIcon}></span>{tooltipMessage}</div>}
                <div className={styles.GstInputfield}>
                    <Box component="form" noValidate autoComplete="off">
                        <TextField
                            id="outlined-basic"
                            label=""
                            variant="outlined"
                            fullWidth
                            value={gstNumber}
                            onChange={handleGstNumberChange}
                            error={!!errorMsg}
                            helperText={errorMsg}
                            inputProps={{
                                maxLength: 35,
                            }}
                            InputProps={{
                                endAdornment: gstNumber && (
                                    <InputAdornment position="end">
                                        <span className={styles.CircleCheckIcon}></span>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Box>
                </div>
                <div className={styles.GstModalActions}>
                    <span
                        className={`${styles.GstModalCta} ${(gstNumber && errorMsg)||(gstNumber==="") ? styles.GstModalCtaDisabled : styles.GstModalCtaFilled}`}
                        onClick={payHandler}
                    >
                        Continue to Pay
                    </span>
                    <span
                        className={`${styles.GstModalCta} ${styles.GstModalCtaOutlined}`}
                        onClick={nonGstpayHandler}
                    >
                        Proceed without GST number
                    </span>
                </div>
            </div>
        </div>
    );
};

export default GSTModal;
